export default {
      id: "cross-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#cross",
      toString: function () {
        return this.url;
      }
    }